module.exports = __webpack_public_path__ + "static/media/paintedWallPattern.5754b9b8.webp";